import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';

import { ParameterResult } from '@models/swagger';
import { TownsParams } from './service';

export enum TownsActions {
  Failure = '[Catalogs Towns] Failure',
  Request = '[Catalogs Towns] Request',
  Success = '[Catalogs Towns] Success',
  Reset = '[Catalogs Towns] Reset',
}

export const TownsFailure = createAction(TownsActions.Failure, props<{ error: HttpErrorResponse }>());

export const TownsRequest = createAction(TownsActions.Request, props<{ parameters?: TownsParams }>());

export const TownsSuccess = createAction(TownsActions.Success, props<{ data: ParameterResult[] }>());

export const TownsReset = createAction(TownsActions.Reset);
